import { connect } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import { CouponModalComponent } from './CouponModalComponent'
import type { ItemInfos } from 'shared/store/ecommerce/order'
import {
    processCouponNavigation,
    setCurrentItemInfos
} from 'shared/store/ecommerce/order'
import type { CacPromotion, Coupon, CouponForm } from 'shared/types'
import {
    addCoupon,
    resetAddCouponSuccess
} from 'shared/store/kingdom/privileges'
import { push } from 'connected-react-router'

const mapStateToProps = (state: RootState) => {
    const {
        addCouponSuccess,
        addCouponError
    } = state.kingdomPrivilegesPageState
    const { promotionsById } = state.ecommerceCatalogState
    const { collectMode, restaurant } = state.ecommerceOrderState
    return {
        addCouponError,
        addCouponSuccess,
        collectMode,
        promotionsById,
        restaurantId: restaurant && restaurant.id
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    addCoupon: (form: CouponForm) => d(addCoupon(form)),
    reset: () => d(resetAddCouponSuccess()),
    setCurrentItemInfos: (itemInfos: ItemInfos) =>
        d(setCurrentItemInfos(itemInfos)),
    processCouponNavigation: (coupon: Coupon, promotion: CacPromotion) =>
        d(processCouponNavigation(coupon, promotion)),
    navigate: (to: string, state?: any) => d(push({ pathname: to, state }))
})
const CouponModal = connect(
    mapStateToProps,
    mapDispatchToProps
)(CouponModalComponent)

export { CouponModal }
